import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { CONSTANTS } from 'src/app/config/constants.module';
import { ZoomToAreaService } from './app-parameter-handler/handler/zoom-to-area/zoom-to-area.service';
import { ZoomToPointService } from './app-parameter-handler/handler/zoom-to-point/zoom-to-point.service';
import { AppParameterHandler } from './app-parameter-handler/model/app-parameter-handler.model';

@Injectable({
  providedIn: 'root',
})
export class AppParameterService {
  private appParameterFunctions: AppParameterHandler[] = [];

  constructor(
    @Inject(CONSTANTS) private CONST: any,
    private activatedRoute: ActivatedRoute,
    private zoomToPointService: ZoomToPointService,
    private zoomToAreaService: ZoomToAreaService
  ) {
    this.registerParameterFunction(zoomToPointService);
    this.registerParameterFunction(zoomToAreaService);
  }

  registerParameterFunction(appParameterFunction: AppParameterHandler) {
    this.appParameterFunctions.push(appParameterFunction);
  }

  handleAppParameter(functionName: string, params: Params) {
    const activeParamFunction = this.appParameterFunctions.find(p => p.name === functionName);
    if (activeParamFunction) activeParamFunction.parameterFunction(params);
  }
}
